import JsBarcode from 'jsbarcode'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import { wtFormatDate, wtGetDateTimeFormat } from 'src/helpers/commons/moment'
import { wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils'
import {
  MATERIAL_LIFTED_FROM_EXTERNAL_STORES,
  PRINT_HISTORY_YES,
  SALE_ORDER_DELIVERY_HOD_STATUS_APPROVED,
  SALE_ORDER_DELIVERY_HOD_STATUS_JUST_PLACED,
  SALE_ORDER_DELIVERY_STATUS_JUS,
  SALE_ORDER_DELIVERY_STATUS_JUST_PLACED,
} from 'src/models/sale-order-delivery'
import {
  SALE_ORDER_CURRENCY_SYMBOL,
  SALE_ORDER_STATUS_JUST_PLACED,
  STATE_PROVINCE_NAMES,
} from 'src/models/sale-orders'

const getDeliveryLocationName = (data) =>
  data?.material_lifted_from === MATERIAL_LIFTED_FROM_EXTERNAL_STORES
    ? data?.factory?.name || ''
    : data?.warehouse?.name || ''

export const SaleOrderDeliveryPDF = (salesOrderData, options = {}) => {
  const {
    openInNewTab = true,
    returnBlob = false,
    onlyOrderConfirmationCopy = false,
    doc: providedDoc = null,
    append = false,
    returnDoc = false,
    showGatePassPendingWatermark = false,
    showGatePassApprovalWatermark = false,
  } = options
  var doc = providedDoc || new jsPDF()
  if (providedDoc && append) {
    doc.addPage()
  }
  var totalPagesExp = '{total_pages_count_string}'
  const logo = 'assets/wil-icon.png'

  console.log(salesOrderData)
  //Order confirmation copy

  applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });

  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRowsFirstTable(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    cellHeight: 20, // Se
    styles: {
      lineColor: '#3c4b64',
      // lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    rowHeight: 15,
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
          data.cell.styles.columnWidth = 'wrap'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      // Header

      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')
      doc.text('POF/WIL', data.settings.margin.left + 16, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }

      //Header Right
      doc.setFontSize(10)

      doc.text('ORDER CONFIRMATION COPY', pageWidth - 60, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)

      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFontSize(10)

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)

      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(wrappedText, data.settings.margin.left + 2, 56)
      // doc.text(salesOrderData.party.ntn ? 'NTN/CNIC'+ salesOrderData.party.ntn : '-' , data.settings.margin.left + 2, 64)
      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 20)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 20)
      // doc.text('Direct: ', 105, pageHeight - 20)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 110, pageHeight - 20,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 15)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 15,)
      // doc.text('Email:', 105, pageHeight - 15)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 110, pageHeight - 15,)

      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('ORDER CONFIRMATION COPY', pageWidth - 120, pageHeight - 4)
    },
  })

  //Set last page content
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

  doc.setTextColor('#3c4b64')
  doc.setFontSize(9)

  //Terms
  doc.setFont('Helvetica', '', 'bold')
  doc.text('Dear Sir,', 15, pageHeight - 60)
  doc.setFontSize(8)
  var bankSplitted = doc.splitTextToSize(
    '1. We feel pleasure in confirming our acceptance of your esteemed order with the following provision-',
    150,
  )
  doc.text(bankSplitted, 20, pageHeight - 56)
  doc.text(
    "A. Company's responsibility cases for quality once goods are delivered to either carriers or customers representative.",
    22,
    pageHeight - 52,
  )
  doc.text(
    'The company will not be responsible for any loss or damage when the goods are in transit with ',
    22,
    pageHeight - 48,
  )
  doc.text('Railways or Road.', 22, pageHeight - 44)
  doc.text(
    "B. Company's responsibility for variation of quantity if any will only be accepted at the time of weighment in the",
    22,
    pageHeight - 40,
  )
  doc.text(
    'presence of either customers representative or the carriers representative.',
    22,
    pageHeight - 36,
  )
  doc.text('2. Despatch Advice will follow soon.', 20, pageHeight - 32)
  doc.text('Assuring you always of our best service and attention.', 22, pageHeight - 28)

  const addBarCode = (doc) => {
    const qrCodeSize = 44
    const qrCodeX = (225 - qrCodeSize) / 2
    const qrCodeY = 27

    const canvas = document.createElement('canvas')
    JsBarcode(canvas, `${salesOrderData.id}-${salesOrderData.code}`, {
      format: 'CODE128', // Specify the barcode format
      displayValue: true, // Display the value below the barcode
      fontSize: 32,
    })
    const barcodeDataURL = canvas.toDataURL('image/png')
    doc.addImage(barcodeDataURL, 'PNG', qrCodeX, qrCodeY, 35, 13) // Adjust position and size as needed
  }
  addBarCode(doc)

  if (onlyOrderConfirmationCopy) {
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    if (returnDoc) {
      return doc
    }

    const pdfBlob = doc.output('blob')

    if (returnBlob) {
      return pdfBlob
    }

    if (openInNewTab) {
      const pdfUrl = URL.createObjectURL(pdfBlob)
      window.open(pdfUrl, '_blank')
    }

    return pdfBlob
  }

  doc.addPage()

  /// POF STORE COPY ////////////


    applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRowsFirstTable(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      // lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
          data.cell.styles.columnWidth = 'wrap'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      // Header

      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.text('POF/WIL', data.settings.margin.left + 16, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }

      //Header Right
      doc.setFontSize(10)
      // doc.text(salesOrderData.code, pageWidth - 48, 6)
      // doc.text('CPS/4/005', pageWidth - 45, 6)
      doc.text('POF STORE COPY', pageWidth - 60, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)

      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )
      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)
      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)
      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)

      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('POF STORE COPY', pageWidth - 120, pageHeight - 4)
    },
  })
  addBarCode(doc)
  doc.addPage()

  /////////////////////////////////////Accounts Copy////////////////////////



    applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, true),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRows(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      // lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      // Header

      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.text(
        salesOrderData.branch.name + '/' + salesOrderData.sale_order.department.name,
        data.settings.margin.left + 5,
        10,
      )

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }

      //Header Right
      doc.setFontSize(10)
      // doc.text(salesOrderData.code, pageWidth - 48, 6)
      // doc.text('CPS/4/005', pageWidth - 45, 6)
      doc.text('ACCOUNT COPY', pageWidth - 60, 10)

      doc.setFontSize(17)
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)

      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)

      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)

      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)
      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')

      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)
      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      const approvedText = 'Approved By'
      const approvedByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const approvedTextWidth = doc.getTextWidth(approvedText)
      const approvedByWidth = doc.getTextWidth(approvedByText)

      const approvedTextX = centerXRight - approvedTextWidth / 2
      const approvedByX = centerXRight - approvedByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      doc.text(approvedText, approvedTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(approvedByText, approvedByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        approvedByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Finance Approval'
      const financeByText = salesOrderData.approved_by ? salesOrderData.approved_by.name : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.approved_by ? salesOrderData.approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)
      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('ACCOUNT COPY', pageWidth - 120, pageHeight - 4)
    },
  })

  //////////////////Sales Copy///////////////

  const addBarCode2 = (doc) => {
    const qrCodeSize = 44
    const qrCodeX = (225 - qrCodeSize) / 2
    const qrCodeY = 27

    const canvas = document.createElement('canvas')
    JsBarcode(canvas, `${salesOrderData.id}-${salesOrderData.code}`, {
      format: 'CODE128', // Specify the barcode format
      displayValue: true, // Display the value below the barcode
      fontSize: 32,
    })
    const barcodeDataURL = canvas.toDataURL('image/png')
    doc.addImage(barcodeDataURL, 'PNG', qrCodeX, qrCodeY, 35, 13) // Adjust position and size as needed
  }
  addBarCode2(doc)
  doc.addPage()


    applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRows(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      //  lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      // Header

      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.text('POF/WIL', data.settings.margin.left + 16, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }

      //Header Right
      doc.setFontSize(10)

      // doc.text(salesOrderData.code, pageWidth - 48, 6)
      // doc.text('CPS/4/005', pageWidth - 45, 6)

      doc.text('SALES COPY', pageWidth - 60, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)

      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)
      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)

      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)

      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('SALES COPY', pageWidth - 120, pageHeight - 4)
    },
  })
  addBarCode2(doc)
  doc.addPage()

  /////////////////////////////////////Cost Office's Copy////////////////////

    applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRows(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      // lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      // Header
      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')
      doc.text('POF/WIL', data.settings.margin.left + 16, 10)
      doc.setFontSize(17)
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')
      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)
      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }
      //Header Right
      doc.setFontSize(10)
      doc.text('COST OFFICE`S COPY', pageWidth - 60, 10)
      doc.setFontSize(17)
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')
      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)
      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)
      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')
      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)

      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)
      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)

      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('COST OFFICE`S COPY', pageWidth - 120, pageHeight - 4)
    },
  })
  addBarCode2(doc)
  doc.addPage()

  ////////////////// FIles Copy////////////////


    applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRows(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      //  lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      // Header
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.text('POF/WIL', data.settings.margin.left + 16, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }
      //Header Right
      doc.setFontSize(10)
      doc.text('FILES COPY', pageWidth - 60, 10)

      doc.setFontSize(17)
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')
      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)
      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)

      //Add header separator
      doc.line(14, 42, 196, 42)
      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)

      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)
      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('FILES COPY', pageWidth - 120, pageHeight - 4)
    },
  })

  addBarCode2(doc)
  doc.addPage()

  /////////////////////////// Despatch Copy //////////////////////

  applyWatermark(doc, salesOrderData, { showGatePassPendingWatermark, showGatePassApprovalWatermark });
  doc.autoTable({
    head: headRows(),
    body: bodyRows(salesOrderData, false),
    theme: 'plain',
    showFoot: 'lastPage',
    foot: footerRows(salesOrderData),
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 180,
    styles: {
      lineColor: '#3c4b64',
      // lineWidth: 0.2,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 7,
      font: 'helvetica',
    },
    didParseCell: function (data) {
      if (data.row.section === 'body') {
        if (data.column.dataKey === 0) {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.fontStyle = 'bold'
          data.cell.styles.halign = 'left'
        } else {
          data.cell.styles.fontSize = 9
          data.cell.styles.textColor = '#3c4b64'
          data.cell.styles.font = 'helvetica'
          data.cell.styles.halign = 'center'
        }
      }
    },
    margin: { top: 69, bottom: 0, left: 15, right: 30 },
    didDrawPage: function (data) {
      //get page no
      let pageNo = doc.internal.getNumberOfPages()

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      // Header

      //Header Left
      doc.setFontSize(10)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.text('POF/WIL', data.settings.margin.left + 16, 10)

      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(data.settings.margin.left + 5, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', data.settings.margin.left + 15, 16)
      doc.text('QUALITY GOODS IN', data.settings.margin.left + 13, 20)
      doc.text('FERROUS & NON FERROUS', data.settings.margin.left + 7, 24)

      //Header middle branch logo
      if (logo) {
        doc.addImage(logo, 'PNG', pageWidth - 112, 2, 15, 15)
        doc.setFontSize(18)
        doc.setFont('Helvetica', 'bold')
        doc.text('WAH INDUSTRIES LIMITED', pageWidth - 144, 23)
        doc.setFontSize(7)
        doc.text('(Commercial Enterprises Of Pakistan Ordnance Factories)', pageWidth - 137, 26)
      }

      //Header Right
      doc.setFontSize(10)
      doc.text('DESPATCH COPY', pageWidth - 60, 10)
      doc.setFontSize(17)

      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(pageWidth - 60, 12, 44, 16, 'FD')

      doc.setFontSize(8)
      doc.text('PRODUCER OF', pageWidth - 50, 16)
      doc.text('12 BORE', pageWidth - 45, 20)
      doc.text('SHAHEEN CARTRIDGES', pageWidth - 55, 24)

      doc.setFontSize(12)
      doc.setFont('Helvetica', 'bold')
      doc.text('DELIVERY ORDER NO: ', data.settings.margin.left + 5, 33)
      // doc.text('Revenue Account ', data.settings.margin.left + 5, 37)
      doc.text(salesOrderData.code, data.settings.margin.left + 52, 33)
      doc.setFontSize(10)
      doc.text(
        salesOrderData.sale_order.revenue_account
          ? salesOrderData.sale_order.revenue_account.name
          : '-',
        20,
        38,
      )

      doc.setFont('Helvetica', 'bold')
      doc.setFontSize(11)
      doc.text('SOD No:', pageWidth - 60, 33)
      doc.text(salesOrderData.sale_order.code, pageWidth - 43, 33)
      doc.text('DATE:', pageWidth - 60, 38)
      doc.line(pageWidth - 61, 39, pageWidth - 27, 39)
      doc.text(wtFormatDate(salesOrderData.delivery_date), pageWidth - 48, 38)
      doc.setFontSize(9)

      //Add header separator
      doc.line(14, 42, 196, 42)

      //Set Customer Details
      doc.setDrawColor(0)
      doc.setFillColor(255, 255, 255)
      doc.rect(15, 45, 180, 25, 'FD')

      const text = salesOrderData.sale_order.customer_po_no
        ? salesOrderData.sale_order.customer_po_no
        : '-'
      const maxWidth = 70 // Adjust this value based on your desired width
      const wrappedText = doc.splitTextToSize(text, maxWidth)
      doc.text('CUSTOMER ORDER NO & DATE: ', data.settings.margin.left + 2, 52)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      // doc.text(salesOrderData.party.name, data.settings.margin.left + 2, 58)
      doc.text(wrappedText, data.settings.margin.left + 2, 56)
      doc.text(
        wtFormatDate(salesOrderData.sale_order.customer_po_date),
        data.settings.margin.left + 2,
        68,
      )
      doc.line(pageWidth - 130, 45, pageWidth - 130, 70)

      const text2 = salesOrderData.sale_order.additional_details
        ? salesOrderData.sale_order.additional_details
        : '-'
      const maxWidth2 = 108 // Adjust this value based on your desired width
      const wrappedText2 = doc.splitTextToSize(text2, maxWidth2)

      doc.setFontSize(10)
      doc.setFont('Helvetica', 'bold')
      doc.text("CUSTOMER'S ADDRESS:", pageWidth - 128, 49)
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'bold')
      doc.text(
        (salesOrderData.party.code
          ? salesOrderData.party.code + ' - ' + salesOrderData.party.name
          : '-') ?? '-',
        pageWidth - 128,
        52,
      )
      doc.setFontSize(9)
      doc.setFont('Helvetica', 'normal')
      doc.text(
        salesOrderData.sale_order.retail_customer_name
          ? salesOrderData.sale_order.retail_customer_name
          : '',
        pageWidth - 128,
        55,
      )
      doc.text(wrappedText2, pageWidth - 128, 58)
      if (salesOrderData.sale_order.retail_customer == 1) {
        doc.text(
          'CNIC : ' +
          salesOrderData.sale_order.retail_customer_cnic +
          ' State : ' +
          STATE_PROVINCE_NAMES[salesOrderData.sale_order.state],
          pageWidth - 128,
          65,
        )
      } else {
        if (salesOrderData.party) {
          let partyInfo = ''
          if (salesOrderData.party.ntn) {
            partyInfo = salesOrderData.party.ntn + ' / '
          }
          if (salesOrderData.party.cnic) {
            partyInfo = partyInfo + '' + salesOrderData.party.cnic
          }

          if (partyInfo) {
            doc.text('NTN/CNIC : ' + partyInfo, pageWidth - 128, 65)
          }
        }
      }
      const text3 = salesOrderData.party.billing_address ?? '-'
      const wrappedText3 = doc.splitTextToSize(text3, maxWidth2)
      doc.text(wrappedText3, pageWidth - 128, 68)

      // Set Footer
      doc.setFontSize(9)

      //Phone No (this should be dynamic. It will come from branch details)
      doc.line(12, pageHeight - 20, 196, pageHeight - 20)
      // doc.setFont('Helvetica', '', 'bold')
      // doc.text('WIL Exchnage: ', 12, pageHeight - 30)
      // doc.text('(051) 905521666, 9314283, 9314381', data.settings.margin.left + 24, pageHeight - 30)
      // doc.text('Direct: ', 12, pageHeight - 26)
      // doc.text('(051) 905523265, 905523202, 905521003', data.settings.margin.left + 24, pageHeight - 26,)
      // doc.text('Fax:', data.settings.margin.left - 3, pageHeight - 22)
      // doc.text('(051) 9314281', data.settings.margin.left + 24, pageHeight - 22,)
      // doc.text('Email:', data.settings.margin.left - 3, pageHeight - 18)
      // doc.text('sales@wahindustries.com', data.settings.margin.left + 24, pageHeight - 18,)

      // doc.setFontSize(10)
      // doc.setFontSize(10)
      // Prepared By (Left)
      const lineStart = 15
      const lineEnd = 65
      const lineWidth = lineEnd - lineStart
      const centerX = lineStart + lineWidth / 2

      const preparedByText = 'Prepared By'
      const createdByText = salesOrderData.created_by.name
      const preparedByWidth = doc.getTextWidth(preparedByText)
      const createdByWidth = doc.getTextWidth(createdByText)

      const preparedByX = centerX - preparedByWidth / 2
      const createdByX = centerX - createdByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStart, pageHeight - 13, lineEnd, pageHeight - 13)
      doc.text(preparedByText, preparedByX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(createdByText, createdByX, pageHeight - 14)
      doc.text(wtGetDateTimeFormat(salesOrderData.created_at), createdByX - 3, pageHeight - 6)
      doc.setTextColor('#3c4b64')

      // Approved By (Center)
      const lineStartRight = 80
      const lineEndRight = 130
      const lineWidthRight = lineEndRight - lineStartRight
      const centerXRight = lineStartRight + lineWidthRight / 2

      // const approvedText = 'Approved By'
      // const approvedByText = salesOrderData.hod_approved_by ? salesOrderData.hod_approved_by.name : '-'
      // const approvedTextWidth = doc.getTextWidth(approvedText)
      // const approvedByWidth = doc.getTextWidth(approvedByText)

      // const approvedTextX = centerXRight - approvedTextWidth / 2
      // const approvedByX = centerXRight - approvedByWidth / 2

      // doc.setFont('Helvetica', 'bold')
      // doc.line(lineStartRight, pageHeight - 13, lineEndRight, pageHeight - 13)
      // doc.text(approvedText, approvedTextX, pageHeight - 10)
      // doc.setTextColor('blue')
      // doc.text(approvedByText, approvedByX, pageHeight - 14)
      // doc.text(
      //   wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
      //   approvedByX - 3,
      //   pageHeight - 6
      // )
      doc.setTextColor('#3c4b64')

      // Prepared By (Right)
      const lineStartFinance = 145
      const lineEndFinance = 195
      const lineWidthFinance = lineEndFinance - lineStartFinance
      const centerXFinance = lineStartFinance + lineWidthFinance / 2

      const financeText = 'Approved By'
      const financeByText = salesOrderData.hod_approved_by
        ? salesOrderData.hod_approved_by.name
        : '-'
      const financeTextWidth = doc.getTextWidth(financeText)
      const financeByWidth = doc.getTextWidth(financeByText)

      const financeTextX = centerXFinance - financeTextWidth / 2
      const financeByX = centerXFinance - financeByWidth / 2

      doc.setFont('Helvetica', 'bold')
      doc.line(lineStartFinance, pageHeight - 13, lineEndFinance, pageHeight - 13)
      doc.text(financeText, financeTextX, pageHeight - 10)
      doc.setTextColor('blue')
      doc.text(financeByText, financeByX, pageHeight - 14)
      doc.text(
        wtGetDateTimeFormat(salesOrderData.hod_approved_by ? salesOrderData.hod_approved_at : ''),
        financeByX - 3,
        pageHeight - 6,
      )
      doc.setTextColor('#3c4b64')

      // doc.text('GM SALES AND MARKETING', pageWidth - 60, pageHeight - 6)

      //Page No
      var str = 'Page ' + pageNo
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }

      // doc.setTextColor('black')
      // doc.text(str, 10, pageHeight - 4)
      // doc.text('DESPATCH COPY', pageWidth - 120, pageHeight - 4)
    },
  })

  addBarCode2(doc)

  // Total page number plugin only available in jspdf v1.0+
  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp)
  }

  if (returnDoc) {
    return doc
  }

  const pdfBlob = doc.output('blob')

  if (returnBlob) {
    return pdfBlob
  }

  if (openInNewTab) {
    const pdfUrl = URL.createObjectURL(pdfBlob)
    window.open(pdfUrl, '_blank')
  }

  return pdfBlob
}

const headRows = () => {
  return [
    [
      {
        content: 'Item',
        datakey: 'item_name',
        styles: {
          halign: 'left',
          valign: 'middle',
          lineWidth: 0.2,
          lineColor: '#3c4b64',
          cellWidth: 65,
        },
      },
      {
        content: 'QTY',
        dataKey: 'qty',
        styles: {
          halign: 'center',
          valign: 'middle',
          lineWidth: 0.2,
          lineColor: '#3c4b64',
          cellWidth: 14,
        },
      },
      {
        content: 'UoM',
        dataKey: 'item_unit',
        styles: {
          halign: 'center',
          valign: 'middle',
          lineWidth: 0.2,
          lineColor: '#3c4b64',
          cellWidth: 13,
        },
      },
      {
        content: 'Rate/Unit\n+GST',
        dataKey: 'unit_price',
        styles: {
          halign: 'center',
          lineWidth: 0.2,
          valign: 'middle',
          lineColor: '#3c4b64',
          cellWidth: 26,
        },
      },
      // { content: 'Sub Total', dataKey: 'rate', styles: { halign: 'center', lineWidth: 0.2, valign: 'middle', lineColor: '#3c4b64', cellWidth: 15 } },
      // { content: 'Taxes', dataKey: 'rate', styles: { halign: 'center', lineWidth: 0.2, valign: 'middle', lineColor: '#3c4b64', cellWidth: 13 } },
      {
        content: 'Total',
        dataKey: 'total',
        styles: {
          halign: 'center',
          lineWidth: 0.2,
          valign: 'middle',
          lineColor: '#3c4b64',
          cellWidth: 22,
        },
      },
      {
        content: 'QTY\nActual\nDelivered',
        dataKey: 'delivered_quantity',
        styles: {
          halign: 'center',
          valign: 'middle',
          lineWidth: 0.2,
          lineColor: '#3c4b64',
          cellWidth: 20,
        },
      },
      {
        content: 'Value Of\nActual QTY',
        dataKey: 'delivered_amount',
        styles: {
          halign: 'center',
          lineWidth: 0.2,
          valign: 'middle',
          lineColor: '#3c4b64',
          cellWidth: 20,
        },
      },
    ],
  ]
}
const bodyRows = (data, showRate) => {
  var body = []
  var Rowlength = data.sale_order_delivery_details.length
  for (var i = 0; i < data.sale_order_delivery_details.length; i++) {
    const delivering_quantity = data.sale_order_delivery_details[i].delivering_quantity
    const unit_price = data.sale_order_delivery_details[i].sale_order_detail.unit_price
    const rate = data.sale_order_delivery_details[i].sale_order_detail.rate
    const unit_price_including_tax =
      data.sale_order_delivery_details[i].sale_order_detail.unit_price_including_tax
    // const tax_amount = (delivering_quantity * unit_price) * (rate / 100)
    const tax_amount = wtRoundValue(unit_price * (rate / 100), 2) * delivering_quantity
    // const net_total = tax_amount + (unit_price * delivering_quantity)
    const net_total = unit_price_including_tax * delivering_quantity
    const unitPriceNumber = parseFloat(unit_price) || 0
    const rateNumber = parseFloat(rate) || 0
    // const totalWithTax = parseFloat((unitPriceNumber + (unitPriceNumber * (rateNumber / 100))).toFixed(2));
    const totalWithTax = parseFloat(unit_price_including_tax).toFixed(2)
    // Extract serial numbers properly
    const itemSerials = data.sale_order_delivery_details[i].item_serials
      .map((serialObj) => serialObj.serial)
      .join(', ')
    let itemDescription = `${data.sale_order_delivery_details[i].item.name}`
    if (data.serial_visiable == 1) {
      if (itemSerials) {
        itemDescription += `\n${itemSerials}`
      }
    }
    if (data.print_history === PRINT_HISTORY_YES || data.print_history === null) {
      itemDescription +=
        '\nTotal Ordered QTY = ' +
        wtRoundValue(data.sale_order_delivery_details[i].sale_order_detail.quantity, 6) +
        '\nQTY Already Delivered = ' +
        wtRoundValue(
          data.sale_order_delivery_details[i].sale_order_detail.delivered_quantity -
          data.sale_order_delivery_details[i].delivering_quantity,
          3,
        ) +
        '\nBalance QTY = ' +
        wtRoundValue(
          data.sale_order_delivery_details[i].sale_order_detail.quantity -
          (data.sale_order_delivery_details[i].sale_order_detail.delivered_quantity -
            data.sale_order_delivery_details[i].delivering_quantity),
          2,
        )
    } else {
      itemDescription += ''
    }
    body.push([
      itemDescription,
      wtRoundValue(data.sale_order_delivery_details[i].delivering_quantity, 6),
      data.sale_order_delivery_details[i].item_unit.name,
      wtFormatRoundedValue(totalWithTax, '', false, 2),
      // wtFormatRoundedValue(data.sale_order_delivery_details[i].delivering_quantity*data.sale_order_delivery_details[i].sale_order_detail.unit_price, '', false, 3,),
      // wtFormatRoundedValue(tax_amount, '', false, 3,),
      wtFormatRoundedValue(net_total, '', false, 3),
      {
        content: showRate
          ? data.sale_order_delivery_details[i].sale_order_detail.tax_head.name +
          ' @' +
          wtFormatRoundedValue(
            data.sale_order_delivery_details[i].sale_order_detail.rate,
            '',
            false,
            2,
          ) +
          '%'
          : '',
        colSpan: 2,
        styles: { halign: 'left' }, // optional
      },
    ])
  }

  if (Rowlength > 5) {
    var k = 0
  } else if (Rowlength == 4) {
    var k = 1
  } else if (Rowlength == 3) {
    var k = 3
  } else if (Rowlength == 2) {
    var k = 4
  } else if (Rowlength == 1) {
    var k = 5
  }
  for (let j = 0; j < k; j++) {
    body.push(['', '', '', ''])
  }

  return body
}

const footerRowsFirstTable = (data) => {
  let grossQtyTotal = 0
  let grossUnitItemsTotal = 0
  let GrossTotalAmount = 0
  let NetTotalValue = 0
  let TotalDiscountAmount = 0
  let totalItems = 0
  let totalItems_2 = 0

  const further_tax_rate = data.sale_order.tax_head ? data.sale_order.tax_head.rate : 0 // Parse further_tax
  const income_tax_head_rate = parseFloat(data.sale_order.income_tax_head_rate) || 0
  for (var i = 0; i < data.sale_order_delivery_details.length; i++) {
    const delivering_quantity_1 =
      parseFloat(data.sale_order_delivery_details[i].delivering_quantity) || 0
    const unit_price_1 = data.sale_order_delivery_details[i].sale_order_detail.unit_price
    const rate_1 = data.sale_order_delivery_details[i].sale_order_detail.rate
    const discountAmount = data.sale_order_delivery_details[i].sale_order_detail.discount_amount
    const total_price =
      parseFloat(data.sale_order_delivery_details[i].sale_order_detail.total_price) || 0
    const unitPriceNumber = parseFloat(unit_price_1) || 0
    const rateNumber = parseFloat(rate_1) || 0
    const discountAmountNumber = parseFloat(discountAmount) || 0
    // const totalWithTax = parseFloat((unitPriceNumber + (unitPriceNumber * (rateNumber / 100))).toFixed(2));
    const unit_price_including_tax =
      data.sale_order_delivery_details[i].sale_order_detail.unit_price_including_tax
    const totalWithTax = parseFloat(unit_price_including_tax).toFixed(2)
    // const tax_amount_1 = (delivering_quantity_1 * unit_price_1) * (rate_1 / 100)
    const tax_amount_1 = wtRoundValue(unit_price_1 * (rate_1 / 100), 2) * delivering_quantity_1

    // const net_total = tax_amount_1 + (unit_price_1 * delivering_quantity_1)
    const net_total = unit_price_including_tax * delivering_quantity_1

    GrossTotalAmount += net_total
    // grossUnitItemsTotal += totalWithTax
    grossQtyTotal += delivering_quantity_1
    totalItems += total_price
    totalItems_2 += unit_price_1 * delivering_quantity_1

    TotalDiscountAmount += discountAmountNumber
  }
  const further_tax = (further_tax_rate / 100) * totalItems_2 // Parse further_tax
  const total_income_tax_amount = (income_tax_head_rate / 100) * (GrossTotalAmount + further_tax) // Parse further_tax
  // Calculate Net Total Value
  // NetTotalValue = GrossTotalAmount + further_tax - TotalDiscountAmount;
  NetTotalValue = GrossTotalAmount + further_tax + total_income_tax_amount
  return [
    [
      {
        content: 'Sub Total',
        // colSpan: 9,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: `${wtRoundValue(grossQtyTotal, 6)}`,
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '',
        colSpan: 1,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '-',
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: `${wtFormatRoundedValue(GrossTotalAmount, '', false, 3)}`,
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
    [
      {
        content: `Further Tax @ ${wtRoundValue(further_tax_rate, 2)}%`,
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: `${wtFormatRoundedValue(further_tax, '', false, 3)}`,
        // colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '',
        colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
    [
      {
        content: `Income Tax @ ${wtRoundValue(income_tax_head_rate, 2)}%`,
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: `${wtFormatRoundedValue(total_income_tax_amount, '', false, 3)}`,
        // colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '',
        colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
    [
      {
        content: 'Net Total',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: `${wtFormatRoundedValue(NetTotalValue, '', false, 3)}`,
        // colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
      {
        content: '',
        colSpan: 2,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
    [
      {
        content: `DELIVERY : ${getDeliveryLocationName(data)}`,
        colSpan: 9,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
    [
      {
        content: 'SPL. INSTRUCTIONS: ',
        colSpan: 9,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          fontSize: 8,
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64', // Set border color
          cellPadding: 2, // Optional: add some padding for better spacing
        },
      },
    ],
  ]
}

const applyWatermark = (
  doc,
  salesOrderData,
  { showGatePassPendingWatermark = false, showGatePassApprovalWatermark = false } = {},
) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.saveGraphicsState();

  doc.setFont('Helvetica', 'bold');
  doc.setTextColor(230, 230, 230);

  let text = '';
  let x = 0;
  let y = 0;
  let fontSize = 70;

  // ✅ DRAFT watermark position
  if (salesOrderData.hod_approval_status === SALE_ORDER_DELIVERY_HOD_STATUS_JUST_PLACED) {
    text = 'Draft';
    fontSize = 100;

    x = 130;
    y = 150;
  }

  // ✅ DO Verification Pending position
  else if (
    salesOrderData.status === SALE_ORDER_DELIVERY_STATUS_JUST_PLACED &&
    salesOrderData.hod_approval_status === SALE_ORDER_DELIVERY_HOD_STATUS_APPROVED
  ) {
    text = 'DO Verification Pending';
    fontSize = 45;

    x = 135;
    y = 200; // 👈 different Y position
  }

  if (showGatePassPendingWatermark && showGatePassApprovalWatermark) {
    text = 'Gate Pass Approval Pending';
    fontSize = 45;
    x = 135;
    y = 200;
  }

  if (text) {
    doc.setFontSize(fontSize);

    doc.text(text, x, y, {
      align: 'center',
      baseline: 'middle',
      angle: 45,
    });
  }

  doc.restoreGraphicsState();
};
const footerRows = (data) => {
  let grossQtyTotal = 0
  let grossUnitItemsTotal = 0
  let GrossTotalAmount = 0
  let NetTotalValue2 = 0
  let TotalDiscountAmount = 0

  let totalItems = 0
  let totalItems_2 = 0

  const further_tax_rate = data.sale_order.tax_head ? data.sale_order.tax_head.rate : 0 // Parse further_tax
  const income_tax_head_rate = parseFloat(data.sale_order.income_tax_head_rate) || 0

  for (var i = 0; i < data.sale_order_delivery_details.length; i++) {
    const delivering_quantity_1 =
      parseFloat(data.sale_order_delivery_details[i].delivering_quantity) || 0
    const unit_price_1 = data.sale_order_delivery_details[i].sale_order_detail.unit_price
    const discountAmount = data.sale_order_delivery_details[i].sale_order_detail.discount_amount
    const rate_1 = data.sale_order_delivery_details[i].sale_order_detail.rate
    const unitPriceNumber = parseFloat(unit_price_1) || 0
    const total_price =
      parseFloat(data.sale_order_delivery_details[i].sale_order_detail.total_price) || 0
    const rateNumber = parseFloat(rate_1) || 0
    const discountAmountNumber = parseFloat(discountAmount) || 0
    // const totalWithTax = parseFloat((unitPriceNumber + (unitPriceNumber * (rateNumber / 100))).toFixed(2));
    const unit_price_including_tax =
      data.sale_order_delivery_details[i].sale_order_detail.unit_price_including_tax
    const totalWithTax = parseFloat(unit_price_including_tax).toFixed(2)

    // const tax_amount_1 = (delivering_quantity_1 * unit_price_1) * (rate_1 / 100)
    const tax_amount_1 = wtRoundValue(unit_price_1 * (rate_1 / 100), 2) * delivering_quantity_1

    // const net_total = tax_amount_1 + (unit_price_1 * delivering_quantity_1)
    const net_total = unit_price_including_tax * delivering_quantity_1
    GrossTotalAmount += net_total
    // grossUnitItemsTotal += totalWithTax
    grossQtyTotal += delivering_quantity_1
    totalItems += total_price
    totalItems_2 += unit_price_1 * delivering_quantity_1

    TotalDiscountAmount += discountAmountNumber
  }
  const further_tax2 = (further_tax_rate / 100) * totalItems_2 // Parse further_tax
  const total_income_tax_amount2 = (income_tax_head_rate / 100) * (GrossTotalAmount + further_tax2) // Parse further_tax

  // Calculate Net Total Value
  // NetTotalValue2 = GrossTotalAmount + further_tax2 - TotalDiscountAmount;
  NetTotalValue2 = GrossTotalAmount + further_tax2 + total_income_tax_amount2

  return [
    [
      {
        content: 'Sub Total',
        // colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `${wtRoundValue(grossQtyTotal, 6)}`,
        // colSpan: 4,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: '',
        colSpan: 1,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: '-',
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `${wtFormatRoundedValue(GrossTotalAmount, '', false, 3)}`,
        // content: '',
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: '',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: ``,
        colSpan: 3,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `Further Tax @ ${wtRoundValue(further_tax_rate, 2)}%`,
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `${wtFormatRoundedValue(further_tax2, '', false, 3)}`,
        // content: '',
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },

      {
        content: ``,
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: `DELIVERY : ${getDeliveryLocationName(data)}`,
        colSpan: 3,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },

      {
        content: `Income Tax @ ${wtRoundValue(income_tax_head_rate, 2)}%`,
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `${wtFormatRoundedValue(total_income_tax_amount2, '', false, 3)}`,
        // content: '',
        colSpan: 1,
        styles: {
          halign: 'center',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: `TOTAL Rs: ${wtFormatRoundedValue(NetTotalValue2, '', false, 3)}`,
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: "SPL. INSTRUCTIONS: \nCUSTOMER's CREDIT BALANCE Rs",
        colSpan: 5,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: 'ADV      Rs',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: 'DISPATCHED \nDELIVERED BY',
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: 'CHECKED BY',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: 'SALES BOOK \nENTERED FOLIO NO',
        colSpan: 4,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: 'NO OF PACKAGES \nPACKED BY',
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content: 'MANAGER (F & A)',
        colSpan: 8,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
    [
      {
        content: 'WEIGHT FREIGHT  Rs. \nR/P NO DATE',
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
      {
        content:
          'ACCTS. ASSTT                   BILL NO \n                                             DATE:',
        colSpan: 8,
        styles: {
          halign: 'left',
          textColor: '#3c4b64',
          lineWidth: 0.2, // Set border line width
          lineColor: '#3c4b64',
          fontSize: 8,
        },
      },
    ],
  ]
}
